export default __webpack_public_path__ + "static/media/direction-arrow.9dc6230b.svg";